import { Injectable } from '@angular/core';
import { Collaboration } from '@pncl/common-models';
import { FLAGS, FlagsService } from '../../flags.service';
import { CustomUrlStorageKeys, URLService } from '../../dynamic-url.service';

import resolveGalactusSocketConfig = Collaboration.Realtime.resolveGalactusSocketConfig;

@Injectable({
  providedIn: 'root',
})
export class GalactusUrlService {
  constructor(private flagsService: FlagsService, private urlService: URLService) {}

  /** Full configured URL (host + optional GKE prefix). Passed to GalactusClient. */
  getGalactusUrl(): string {
    return this._getGalactusUrl();
  }

  /** Socket.IO origin only (protocol + host[+port]). */
  getGalactusHost(): string {
    return resolveGalactusSocketConfig(this._getGalactusUrl()).origin;
  }

  /** Socket.IO path (/galactus or /galactus-k8s[/preview-N]/galactus). */
  getGalactusPath(): string {
    return resolveGalactusSocketConfig(this._getGalactusUrl()).path;
  }

  private _getGalactusUrl() {
    const customUrl = this.urlService.getCustomUrl(CustomUrlStorageKeys.GalactusServerUrlKey);

    if (customUrl) {
      return customUrl;
    }

    const optimizelyUrl = this.getOptimizelyGalactusUrl();

    if (optimizelyUrl) {
      return optimizelyUrl;
    }

    return this.urlService.getDefaultUrl(CustomUrlStorageKeys.GalactusServerUrlKey);
  }

  private getOptimizelyGalactusUrl(): string | undefined {
    if (!this.flagsService.isFlagEnabled(FLAGS.GALACTUS_URL)) {
      return undefined;
    }

    const galactusUrl = this.flagsService.featureFlagsVariables[FLAGS.GALACTUS_URL]?.galactus_url;

    if (typeof galactusUrl !== 'string') {
      return undefined;
    }

    // By default unitized variables in optimizely are set to an empty string
    if (galactusUrl.trim().length === 0) {
      return undefined;
    }

    return galactusUrl;
  }
}
